import { ControlDataType } from '../../classes/dynamic-form/dynamic-form.class';
import { roundHalfAwayFromZero } from '../../utility/round.util';

/** A choice value is set even when it is 0, which is a valid option value. */
export function isOptionValueSet(value: unknown): boolean {
  return value !== null && value !== undefined && value !== '';
}

/**
 * The chosen option values as text, from one value or a multi-select's list. Compared as text
 * because 0 is a real option and `0 == ['']` — an empty multi-select — is true. Trimmed: the form
 * joins a multi-select with ', ' and splits it on ','.
 */
export function selectedOptionValues(selected: unknown): Set<string> {
  const values = Array.isArray(selected) ? selected : [selected];
  return new Set(
    values
      .filter(isOptionValueSet)
      .map((value) => String(value).trim())
      .filter(Boolean),
  );
}

/**
 * Rounds to the column's decimal places; with none known, the number is kept as typed. Undefined
 * counts as unknown: rounding to it would turn the number into NaN.
 */
export function roundToPrecision(
  value: number,
  precision: number | null | undefined,
): number {
  if (!Number.isFinite(value) || typeof precision !== 'number' || precision < 0)
    return value;
  return roundHalfAwayFromZero(value, precision);
}

/** Types the inline input can capture. Any other type falling back to it is shown read-only: what is typed would be dropped. */
const TYPED_DATA_TYPES = new Set<string>([
  ControlDataType.StringType,
  ControlDataType.MemoType,
  ControlDataType.IntegerType,
  ControlDataType.DecimalType,
  ControlDataType.DoubleType,
  ControlDataType.MoneyType,
]);

export function capturesTyping(dataType: string): boolean {
  return TYPED_DATA_TYPES.has(dataType);
}
